import { CALL_API } from '../../../middleware/api';
import * as ActionType from '../expay';
function fetchRechargeExpay(data) {
    var _a;
    return _a = {
            type: ActionType.FETCH_RECHARGE_EXPAY
        },
        _a[CALL_API] = {
            endpoint: '/payment/expay/create-invoice',
            method: 'post',
            types: [ActionType.SUCCESS_FETCH_RECHARGE_EXPAY, ActionType.FAILURE_FETCH_RECHARGE_EXPAY],
            credentials: true,
            data: data
        },
        _a;
}
export function rechargeExpay(data) {
    return function (dispatch) {
        dispatch(fetchRechargeExpay(data));
    };
}
export function clearRechargeExpay() {
    return function (dispatch) {
        dispatch({ type: ActionType.CLEAR_RECHARGE_EXPAY });
    };
}
export function checkExpayStatus(invoiceId) {
    return function (dispatch) {
        var _a;
        dispatch((_a = {
                type: ActionType.FETCH_CHECK_EXPAY_STATUS
            },
            _a[CALL_API] = {
                endpoint: "/payment/expay/check/".concat(invoiceId),
                method: 'get',
                types: [
                    ActionType.SUCCESS_FETCH_CHECK_EXPAY_STATUS,
                    ActionType.FAILURE_FETCH_CHECK_EXPAY_STATUS
                ],
                credentials: true
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/recharge/creators/expay.js